module.exports = __webpack_public_path__ + "img/anm1.585836fe.png";